<template>
  <div>
    <v-menu
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <template v-slot:activator="{on, attrs}">
        <v-text-field
          :dense="dense"
          :error-messages="errorMessages"
          label="Период"
          type="text"
          v-model="displayText"
          v-bind="attrs"
          v-on="on"
          readonly
          append-icon="mdi-calendar"
        >
        </v-text-field>
      </template>
      <v-card>
        <v-row>
          <v-col cols="6">
            <v-date-picker
              v-model="date1"
              no-title
              locale="ru-ru"
              first-day-of-week="1"
            ></v-date-picker>
          </v-col>
          <v-col cols="6">
            <v-date-picker
              v-model="date2"
              no-title
              locale="ru-ru"
              first-day-of-week="1"
            ></v-date-picker>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn
            class="px-4"
            outlined
            @click.prevent="clearClick"
          >Сбросить</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="px-6"
            outlined
            @click.prevent="cancelClick"
          >Отмена</v-btn>
          <v-btn
            class="px-4"
            color="primary"
            @click.prevent="okClick"
          >Применить</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ['value', 'dense', 'errorMessages'],

  data: () => ({
    dateMenu: false,
    date1: '',
    date2: '',
    oldDate1: '',
    oldDate2: ''
  }),

  watch: {
    dateMenu (val) {
      if (val) {
        this.oldDate1 = this.date1
        this.oldDate2 = this.date2
      }
    }
  },

  computed: {
    displayText: function () {
      let str = ''
      if (this.date1) str = 'с ' + this.getDDMMYYYY(this.date1)
      if (this.date2) str += (str.length > 0 ? ' ' : '') + 'по ' + this.getDDMMYYYY(this.date2)
      if (str.length === 0) {
        str = 'За всё время'
      }
      return str
    }
  },

  methods: {
    getDDMMYYYY (val) {
      const date = val.substring(0, 10)
      return date.slice(8, 10) + '.' + date.slice(5, 7) + '.' + date.slice(0, 4)
    },

    clearClick () {
      this.date1 = ''
      this.date2 = ''
      this.$emit('input', { dateFrom: this.date1, dateTo: this.date2 })
      this.dateMenu = false
    },

    cancelClick () {
      this.dateMenu = false
      this.date1 = this.oldDate1
      this.date2 = this.oldDate2
    },

    okClick () {
      this.$emit('input', { dateFrom: this.date1, dateTo: this.date2 })
      this.dateMenu = false
    }
  },

  created () {
    this.date1 = this.value.dateFrom
    this.date2 = this.value.dateTo
  }
}
</script>
